<template>
  <el-card v-loading="loading">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Kapcsolattartók</span>
      <el-button
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        @click="onCreate"
        icon="el-icon-plus"
      >
        Új Kapcsolattartó
      </el-button>
    </div>
    <el-alert
      v-if="!contactPeople || !contactPeople.length"
      title="Ehhez a partnerhez még nem tartozik kapcsolattartó. Adj hozzá egyet."
      type="info"
      show-icon
      :closable="false"
    />
    <el-table
      :data="contactPeople"
      v-if="contactPeople && contactPeople.length"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="contactPerson"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <contact-person-actions
            :contactPerson="scope.row"
            @update="onUpdate"
            @delete="onDelete"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      :title="contactPersonFormType === 'add' ? 'Új Kapcsolattartó' : 'Kapcsolattartó módosítás'"
      @close="onClose"
      append-to-body
      :close-on-click-modal="false"
      width="680px"
    >
      <contact-person-form
        ref="contactPersonForm"
        :defaultContactPerson="selectedContactPerson"
        :formType="contactPersonFormType"
      />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storeContactPerson"
        >
          {{ contactPersonFormType === 'add' ? 'Hozzáadás' : 'Módosítás' }}
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
  import ContactPersonForm from './ContactPerson';
  import ContactPersonActions from './ContactPersonActions';
  import columns, { allColumns, labels } from './columns';
  import TableSettings from '../.././../../TableSettings';


  export default {
    components: {
      ContactPersonForm,
      ContactPersonActions,
      ...columns,
      TableSettings,
    },
    props: ['contactPeople'],
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        showDialog: false,
        dialogType: 'add',
        contactPersonFormType: 'add',
        selectedContactPerson: {},
      };
    },
    computed: {
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['contactPerson/tableConfig']));
      },
      loading() {
        return this.$store.getters['contactPerson/loading'];
      },
    },
    methods: {
      onClose() {
        this.showDialog = false;
        this.$refs.contactPersonForm.render();
      },
      onCreate() {
        this.contactPersonFormType = 'add';
        this.showDialog = true;
      },
      onUpdate(contactPerson) {
        this.selectedContactPerson = Object.assign({}, contactPerson);
        this.contactPersonFormType = 'update';
        this.showDialog = true;
      },
      onDelete(contactPerson) {
        const contactPeople = this.contactPeople.filter(a => ((a.id && a.id !== contactPerson.id) || a.key !== contactPerson.key));
        this.$emit('change', contactPeople);
      },
      storeContactPerson() {
        const contactPerson = Object.assign({}, this.$refs['contactPersonForm'].contactPerson);
        this.$refs['contactPersonForm'].$refs['contactPersonForm'].validate(async valid => {
          if (valid) {
            if (this.contactPersonFormType === 'add') {
              const newContactPerson = {
                ...contactPerson,
                key: Math.random().toString(36).substring(7),
              };
              this.$emit('add', newContactPerson);
            } else {
              const contactPeople = this.contactPeople.map(c => {
                if ((c.id && c.id === contactPerson.id) || (c.key && c.key === contactPerson.key)) {
                  return contactPerson;
                } else {
                  return c;
                }
              });
              this.$emit('change', contactPeople);
            }
            this.onClose();
          }
        });
      },
    },
    async mounted() {
      await this.$store.dispatch('contactPerson/fetchTableConfig');
    }
  };
</script>
